export default __webpack_public_path__ + "images/aeed470cef74d41ad9866ef100a19b5d.svg";